import { GetB2bOperationErOneResponse } from '@Common/types/bo/b2b/operations_er';

export const b2bOperationsErTranslations = {
  fields: {
    id: 'ID Transaction',
    operation_nature: 'Nature',
    operation_type: "Type d'opération",
    amount_gross: 'Montant total brut',
    amount_net: 'Montant total net',
    products: 'Équipement',
    employee_count: 'Nombre de salariés éligibles',
    reference_period_start_date: 'Période de référence',
    reference_period_end_date: 'Fin de la période de référence',
    from_reference_period_start_date: 'Début de Période de référence',
    to_reference_period_end_date: 'Fin de Période de référence',
    processing_date: 'Date de traitement',
    from_processing_date: 'Date de traitement après le',
    to_processing_date: 'Date de traitement avant le',
  } satisfies Record<
    | keyof GetB2bOperationErOneResponse
    | 'from_reference_period_start_date'
    | 'to_reference_period_end_date'
    | 'from_processing_date'
    | 'to_processing_date',
    string
  >,
  choices: {
    nature: {
      MV: 'Mouvement',
      AN: 'Annulation',
      IM: 'Annulation suite à un impayé',
    } satisfies Record<GetB2bOperationErOneResponse['operation_nature'], string>,

    type: {
      ABONDEMENT: 'Abondement Individuel',
      ABONDEMENT_COLL: 'Abondement Collectif',
      ABONDEMENT_DES: 'Désinvest. Abondement',
      ABONDEMENT_INV: 'Invest. Abondement',
      AFF_ABONDE: 'Affect. Abondement',
      AFF_COT: 'Affectation de cotisation',
      AFF_COT_E: 'Affectation de cotisation (E)',
      AFF_COT_EXO: 'Affectation de cotisation exonérée',
      AFF_COT_RATT: 'Affectation de cotisation (RATT)',
      AFF_COT_RATT_E: 'Affectation de cotisation (RATT_E)',
      AFF_COT_RATT_S: 'Affectation de cotisation (RATT_S)',
      AFF_COT_S: 'Affectation de cotisation salarié',
      AFF_INTERESS: 'Affect. Interess',
      AFF_PARTICIP: 'Affect. Particip',
      AFF_PPV: 'Affectation PPV',
      AFF_PPVE: 'Affectation PPVE',
      AFF_VERS_CET: 'Affect. CET',
      ARB: 'Arbitrage',
      ARB_ATT: 'Arbitrage attente',
      ARB_ATT_DES: "Arbitrage d'attente sortant",
      ARB_ATT_EST_DES: "Arbitrage d'attente estim sortant",
      ARB_ATT_EST_INV: "Arbitrage d'attente estim entrant",
      ARB_ATT_INV: "Arbitrage d'attente entrant",
      ARB_AU_DES: 'Arbitrage sortant automatique',
      ARB_AU_INV: 'Arbitrage entrant automatique',
      ARB_CATT_DES: "Arbitrage de compte d'attente sortant",
      ARB_CATT_INV: "Arbitrage de compte d'attente entrant",
      ARB_CO: 'Arbitrage collectif',
      ARB_CO_DES: 'Arbitrage sortant collectif',
      ARB_CO_INV: 'Arbitrage entrant collectif',
      ARB_COM: 'Arbitrage commercial',
      ARB_COM_DES: 'Arbitrage sortant commercial',
      ARB_COM_INV: 'Arbitrage entrant comercial',
      ARB_DES: 'Arbitrage sortant',
      ARB_INV: 'Arbitrage entrant',
      ARB_PSAP_DES: 'Arbitrage Sortant PSAP',
      ARB_PSAP_INV: 'Arbitrage Entrant PSAP',
      ARB_REBAL_DES: 'ARB_REBAL_DES',
      ARB_REBAL_INV: 'ARB_REBAL_INV',
      ARB_SECU_DES: 'Arbitrage de sécurisation sortant',
      ARB_SECU_INV: 'Arbitrage de sécurisation entrant',
      AVANCE_FDS_RLMT: 'Avance fonds de roulement',
      CC_REVALO: 'Capitaux Constitutifs de Revalorisations',
      CC_REVALO_39: 'CC de revalorisation',
      COM_FDS_COLL: 'Commission sur fonds collectif A39',
      COTI_ANTIC: 'Cotisation anticipée',
      COTI_EXCEP: 'Cotisation exceptionnelle',
      COTI_RATT: 'Cotisation de rattrapage',
      COTI_RATT_E: 'Cotisation de rattrapage (E)',
      COTI_RATT_S: 'Cotisation de rattrapage (S)',
      COTI_REGUL: 'Cotisation de régularisation',
      COTIS: 'Cotisation',
      COTIS_DES: 'Désinvestissement Cotisation',
      COTIS_E: 'Cotisation Entreprise',
      COTIS_ESTIM: 'Cotisation estimée',
      COTIS_ESTIM_N: 'Cotisation estimée (N)',
      COTIS_EXO: "Cotisation exonération versée par l'assureur",
      COTIS_EXO_INV: 'Investissement Cotisation Exonération',
      COTIS_INV: 'Investissement Cotisation',
      COTIS_S: 'Cotisation Salarié',
      D_TR_E_C_E: 'Demande de transfert entrant collectif externe',
      D_TR_E_C_E_DES: 'Demande de Transfert Entrant Collectif Externe - Désinvestissement',
      D_TR_E_C_E_INV: 'Demande de Transfert Entrant Collectif Externe - Investissement',
      D_TR_E_C_I: 'Demande de transfert entrant collectif interne',
      D_TR_E_C_I_DES: 'Demande de Transfert Entrant Collectif Interne - Désinvestissement',
      D_TR_E_C_I_INV: 'Demande de Transfert Entrant Collectif Interne - Investissement',
      D_TR_S_C_E: 'Demande de transfert sortant collectif externe',
      D_TR_S_C_I: 'Demande de transfert sortant collectif interne',
      DC_ACTIF_39: "Décès d'actif (39)",
      DECES_ACTIF: "Décès d'actif",
      DC_PREST: 'Prestation de décès',
      DC_REGL: 'Règlement de décès',
      FISCALITE: 'Fiscalité',
      FR_CPT_ENT: "Frais de gestion du contrat de l'entreprise",
      FR_CPT_SOUS: 'Frais de gestion du contrat du salarié',
      FR_DC_EU: 'Frais de décès euro',
      FR_DC_UC: 'Frais de décés UC',
      FR_ENC_MIN: 'Frais de depart',
      FR_EU: 'Frais de gestion euro',
      FR_EU_COMPL: 'frais sur encours complémentaires',
      FR_EU_REDUC: 'frais gestion si départ',
      FR_FCL: 'Frais IFC/IL',
      FR_GAR_PLAN: 'Frais de garantie plancher',
      FR_PRIME: 'Prime 100% frais',
      FR_REDUC: 'Frais de réduction',
      FR_RENTE: 'Frais de service rente',
      FR_TABLE_EU: 'Frais de Table Euro',
      FR_TABLE_UC: 'Frais de table UC',
      FR_UC: 'Frais de gestion UC',
      FR_UC_COMPL: 'Marge, frais pris sur certains contrats PCLOG',
      INTERESS_DES: 'Désinvest. Interess',
      INTERESS_EXCEPT: 'Intéressement exceptionnel',
      INTERESS_INV: 'Invest. Interess',
      INTERESS_REGUL: 'Intéressement régularisation',
      INTERESSEMENT: 'Intéressement',
      NANTISSEMENT: 'Nantissement',
      OST_DDC: 'Détachement de coupon',
      OST_FA_DES: 'Fusion / Acquisition Sortant',
      OST_FA_INV: 'Fusion / Acquisition Entrant',
      PAR: 'Participation au résultat',
      PARTICIP_DES: 'Désinvest. Particip',
      PARTICIP_EXCEPT: 'Participation exceptionnelle',
      PARTICIP_INV: 'Invest. Particip',
      PARTICIP_REGUL: 'Participation régularisation',
      PARTICIPATION: 'Participation',
      PB: 'Participation aux bénéfices',
      PB_FDS_RENTE: 'Participation aux Bénéfices du compte de rentes',
      PB_GAR_CAPITAL: 'Garantie en Capital',
      PERT_TECH_39: 'Pertes techniques',
      PM_AJUST: "Ajustement d'encours",
      PPV: 'Prime de partage de Valeur',
      PPV_DES: 'Désinvest. PPV',
      PPV_E: 'Prime de Partage de la Valorisation de l’entreprise',
      PPV_INV: 'Invest. PPV',
      PPVE_DES: 'Désinvest. PPVE',
      PPVE_INV: 'Invest. PPVE',
      PRA: 'Participation au résultat (anticipé)',
      PREST_39: 'Prestation Article 39',
      PREST_CC: 'Prestation de Capitaux Constitutifs du fond de revalorisation',
      PREST_FILLON: 'Prestation Fillon',
      PREST_IFC: 'Prestation IFC',
      PREST_IL: 'Prestation IL',
      PRLV_FISC: 'Prélèvement Fiscaux',
      PRLV_FISC_OBLIG: 'Prélèvement Fiscaux Obligatoires',
      PRLV_SOC: 'Prélèvement Sociaux',
      PRST_CHARGE_SOC: 'Prestation charges sociales',
      PRST_EXECEPTION: 'Prestation exceptionnelle',
      PSAP: 'Provision sinistres à payer',
      PSAP_EA: 'EA avant PSAP',
      PSAP_PREST: 'Prest. Compl.',
      PVP: 'Prélévement de versement programmé',
      RB_PRLV_SOC: 'Remboursement prélèvement sociaux',
      RBT_CARENCE_39: 'Remboursement pour délai de carence (39)',
      RBT_CARENCE: 'Remboursement pour délai de carence',
      REG_ACTIF: 'Régularisation actif',
      REG_PASSIF: 'Régularisation passif',
      REGLE_COM_ENC: 'Reglement de commissions sur encours',
      REGLE_COM_MVT: 'Reglement de commissions sur mouvements',
      REMB_FDS_RLMT: 'Remboursement fonds de roulement',
      REX: 'Rachat exceptionnel',
      RP: 'Rachat partiel',
      RPP: 'Rachat partiel programmé',
      RT: 'Rachat total',
      SOR_CAPITAL: 'Sortie en capital',
      SOR_CAPITAL_ENT: 'Sortie en capital entreprise',
      SOR_RENTE: 'Sortie en rente',
      SOR_RENTE_ENT: 'Sortie en rente entreprise',
      SOR_RENTE_UNIQ: 'Sortie en rente unique',
      T_PEP: 'Pertes et profits',
      TMG: 'Part de la revalorisation lié au taux minimum garanti',
      TR_E_C_I_STOCK: 'Transfert entrant collectif en stock',
      TR_ENT_C_E: 'Transfert entrant collectif externe',
      TR_ENT_C_I: 'Transfert entrant collectif interne',
      TR_ENT_C_RENTE: 'Transfert Entrant Collectif de Capitaux Constitutifs de Rentes',
      TR_ENT_E: 'Transfert entrant externe',
      TR_ENT_I: 'Transfert entrant interne',
      TR_ENT_I_STOCK: 'Transfert entrant indivuduel en stock',
      TR_ENTR_EXC_REV: 'Excédent du fonds de revalorisation A39',
      TR_ENTR_REVALO: 'Entrée de PM provenant du fonds de revalorisation A39',
      TR_SOR: 'Transfert Sortant',
      TR_SOR_C_E: 'Transfert sortant collectif externe',
      TR_SOR_C_I: 'Transfert sortant collectif interne',
      TR_SOR_C_P_E:
        'Transfert sortant collectif partiel externe pour les contrats avec vue salariés',
      TR_SOR_C_P_I:
        'Transfert sortant collectif partiel interne pour les contrats avec vue salariés',
      TR_SOR_E: 'Transfert sortant externe',
      TR_SOR_I: 'Transfert sortant interne',
      TR_SOR_PAR_C_E:
        'Transfert Sortant Partiel Collectif Externe pour les contrats sans vue salariés',
      TR_SOR_PAR_C_I:
        'Transfert Sortant Partiel Collectif Interne pour les contrats sans vue salariés',
      TR_SORT_REVALO: 'Sortie de PM vers le fonds de revalorisation A39',
      TR_TECHNIQUE: 'Transfert technique',
      V1: 'Versement initial',
      VERS_CET: 'Vers. CET',
      VERS_CET_DES: 'Désinvest. Vers CET',
      VERS_CET_INV: 'Invest. Vers CET',
      VERS_CET_REGUL: 'Vers. CET régularisation',
      VL: 'Versement libre',
      VL_ENT: 'Versement libre entreprise',
      VL_GRA: 'Versement Gratuit',
      VP: 'Versement programmé',
      VP_ENT: 'Versement programmé entreprise',
    } satisfies Record<GetB2bOperationErOneResponse['operation_type'], string>,
  },
  tabs: {
    in_progress: 'En cours',
    history: 'Historique',
  },
};
